module.exports = __webpack_public_path__ + "img/logo1.d1a3d165.png";